import React from 'react';
import { Link } from 'react-router-dom';

const UnauthorizedPage = () => {
  return (
    <div>
      <h2>Unauthorized Access</h2>
      <p>You are not authorized to access this page.</p>
      <Link to="/login">Go to Login</Link>
    </div>
  );
};

export default UnauthorizedPage;
